import React from 'react';

import Layout from '../../containers/Layout';
import { Container } from './styles';
import ImageTitle, { Icons } from '../../components/ImageTitle';

const SaleNotAllowed: React.FC = () => {
  return (
    <Layout dark>
      <Container data-cy="sale-not-allowed-message">
        <ImageTitle
          icon={Icons.alertOrder}
          text="Ops, este parceiro não suporta venda para pessoa jurídica."
          primary
        />
      </Container>
    </Layout>
  );
};

export default SaleNotAllowed;
